"use client";

import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useEffect, useRef } from "react";

function WebEngagePageViewEvent({ eventName, eventData }) {
  const hasRunRef = useRef(false); // Use a ref to track if the event has already been run
  const isWebEngageEnabled = useFeatureFlag("webEngage");

  useEffect(() => {
    if (!isWebEngageEnabled || hasRunRef.current) {
      return;
    }

    if (window.webengage && window.webengage.track) {
      window.webengage.onReady(function () {
        // Reload webengage on page url locale change
        window.webengage.reload();
        // Track event
        window.webengage.track(eventName, eventData);
        hasRunRef.current = true;
      });
    } else {
      console.error(
        "WebEngage is not initialized or track function is not available"
      );
    }
  }, [isWebEngageEnabled, eventData, eventName]);

  return null;
}

export default WebEngagePageViewEvent;
